export const DriverStatus = {
    activeDriver: {
        label: 'Active Driver',
        value: 'Active Driver',
    },
    interestedMailDelivered: {
        label: 'Mail Delivered',
        value: 'interested_mail_delivered',
    },
    formerDriver: {
        label: 'Former Driver',
        value: 'former_driver',
    },
    formerMailDelivered: {
        label: 'Former - Mail Delivered',
        value: 'former_driver_mail_delivered',
    },
    waitlisted: {
        label: 'Waitlisted',
        value: 'waitlisted',
    },
};


enum DriverStatusEnum {
    APPROVED = 'approved',
    TOS_COMPLETE = 'tos_complete',
    DRIVER_INFO_COMPLETE = 'driver_info_complete',
    PROFILE_COMPLETE = 'profile_complete',
    PAYMENT_COMPLETE = 'payment_complete',
    READY_FOR_TABLET = 'interested_ready_for_tablet',
    NOT_INTERESTED = 'not_interested',
    DO_NOT_CONTACT = 'do_not_contact',
    MAIL_DELIVERED = 'interested_mail_delivered',
    MAILING_ISSUE = 'interested_mailing_issue',
    MAIL_IN_PROCESS = 'interested_mail_in_process',
    FORMER_DRIVER = 'former_driver',
    FORMER_DRIVER_MAIL_DELIVERED = 'former_driver_mail_delivered',
    ACTIVE_DRIVER = 'Active Driver',
    WAITLISTED = 'waitlisted',
    INTERESTED_DNQ_MARKET = 'interested_dnq_market',
    INTERESTED_DNQ_OTHER = 'interested_dnq_other',
    INTERESTED_DNQ_RIDES = 'interested_dnq_rides'
}

export { DriverStatusEnum };

// Statuses that never get the Uber reauth flow (no relink redirect, no relink page state).
export const UBER_REAUTH_EXCLUDED_STATUSES: string[] = [
    DriverStatusEnum.DO_NOT_CONTACT,
    DriverStatusEnum.NOT_INTERESTED,
    DriverStatusEnum.WAITLISTED,
    DriverStatusEnum.INTERESTED_DNQ_RIDES,
    DriverStatusEnum.INTERESTED_DNQ_MARKET,
    DriverStatusEnum.INTERESTED_DNQ_OTHER,
];

// Statuses that see the reauth prompt as a dashboard panel instead of being redirected to the relink page.
export const UBER_REAUTH_DASHBOARD_STATUSES: string[] = [
    DriverStatusEnum.ACTIVE_DRIVER,
    DriverStatusEnum.MAIL_DELIVERED,
    DriverStatusEnum.FORMER_DRIVER,
    DriverStatusEnum.FORMER_DRIVER_MAIL_DELIVERED,
];

export const UBER_REAUTH_MESSAGE_ACTIVE =
    'Action required: Your Uber account link has expired. Please reconnect your Uber account to ensure JourneyTV can continue displaying on your tablet.';
export const UBER_REAUTH_MESSAGE_TABLET =
    'Action required: Your Uber account link has expired. Please reconnect your Uber account to get a tablet.';

export function getUberReauthMessage(status: string | null | undefined): string {
    return status === DriverStatusEnum.ACTIVE_DRIVER ? UBER_REAUTH_MESSAGE_ACTIVE : UBER_REAUTH_MESSAGE_TABLET;
}
